import dotProp from 'dot-prop-immutable'
import {
  REFRESH_CROP_VALUES_BACKGROUND,
  REFRESH_CROP_VALUES_PICTURE,
  START_CROPPING,
} from '../../constants/projectActions'
import {startGaugingUp} from "../wallpapers";

export const startCropping = (cropType = 'picture') => (dispatch, ownState) => {
  const state = ownState()
  const currentCrop = dotProp.get(state, 'project.allowToCrop', false)
  if(cropType == false){
    const first = dotProp.get(state, 'project.background.first', false)
    if(first){
      dispatch(startGaugingUp())
    }
  }
  if (currentCrop === cropType) {
    return dispatch({ type: START_CROPPING, value: false })
  }
  return dispatch({ type: START_CROPPING, value: cropType })
}
export const refreshCrop = crop => (dispatch, ownState) => {
  const cropType = dotProp.get(ownState(), 'project.allowToCrop', false)

  switch (cropType) {
    case 'picture':
      dispatch({ crop, type: REFRESH_CROP_VALUES_PICTURE })
      break
    case 'background':
      dispatch({ crop, type: REFRESH_CROP_VALUES_BACKGROUND })
      break
    default:
      return
  }
}



// WEBPACK FOOTER //
// ./src/actions/project/crop.js